/*
  Échantillons limités à 1 par produit dans le panier.

  Le Liquid retire déjà les sélecteurs de quantité des échantillons (fiche, panier, tiroir)
  et bloque le bouton d'ajout quand l'échantillon est déjà au panier. Ce script rattrape
  les autres cas (double clic, ajout depuis le bloc équivalent puis depuis la fiche, onglet
  resté ouvert) : à l'ouverture d'une page (si un échantillon est au panier) et après chaque
  mise à jour du panier, toute variante d'échantillon dont la quantité totale dépasse 1
  est ramenée à 1.

  Variantes concernées : window.tsiEchantillons, rempli dans layout/theme.liquid.
  Limite : l'API panier reste appelable directement, ce script n'est pas un blocage au
  paiement. Seule une validation au checkout (app) bloque à coup sûr.
*/
(() => {
  const ids = new Set((window.tsiEchantillons || []).map(Number));
  if (!ids.size || !window.routes) return;

  const SOURCE = 'tsi-echantillons';
  let enCours = false;

  const changer = (key, quantity) =>
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });

  // Recharge le tiroir panier (CartItems.onCartUpdate) et la pastille du header
  const rafraichir = async () => {
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
      return;
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
    }
    const bulle = document.getElementById('cart-icon-bubble');
    if (!bulle) return;
    try {
      const sections = await fetch(`${window.routes.cart_url}?sections=cart-icon-bubble`).then((r) => r.json());
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const contenu = html.querySelector('.shopify-section');
      if (contenu) bulle.innerHTML = contenu.innerHTML;
    } catch (e) {
      console.error(e);
    }
  };

  const verifier = async () => {
    if (enCours) return;
    enCours = true;
    try {
      const panier = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
      // Une même variante peut occuper plusieurs lignes (propriétés différentes) :
      // on garde la première ligne à 1 et on retire les suivantes
      const vus = new Set();
      const corrections = [];
      for (const item of panier.items) {
        if (!ids.has(item.variant_id)) continue;
        if (vus.has(item.variant_id)) {
          corrections.push([item.key, 0]);
        } else {
          vus.add(item.variant_id);
          if (item.quantity > 1) corrections.push([item.key, 1]);
        }
      }
      if (!corrections.length) return;
      for (const [key, quantity] of corrections) {
        await changer(key, quantity);
      }
      await rafraichir();
    } catch (e) {
      console.error(e);
    } finally {
      enCours = false;
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === SOURCE) return;
      verifier();
    });
  }
  // Au chargement, seulement si le Liquid a vu un échantillon au panier
  if (window.tsiEchantillonAuPanier) verifier();
})();
